<template>
  <v-col xs="6" sm="6" md="6" lg="6" xl="3">
    <v-hover v-slot:default="{ hover }">
      <v-card
        class="pa-2"
        :style="{
          border: '1px solid var(--primary-boarder-color)',
          borderBlockEndColor: color,
          borderBlockEndWidth: hover ? '3px' : '1px',
          marginBlockEnd: hover ? '-2px' : '',
        }"
      >
        <v-card-text>
          <div class="d-flex align-center gap-x-4 mb-2">
            <v-avatar
              :color="color"
              size="40"
              variant="tonal"
              class="rounded-lg"
            >
              <v-icon size="x-large" color="white">{{ icon }}</v-icon>
            </v-avatar>
          </div>
          <h6 class="text-h6 font-weight-regular">{{ title }}</h6>
          <div class="d-flex align-center">
            <div class="text-body-1 font-weight-regular me-2">
              {{ value || 0 }}
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-hover>
  </v-col>
</template>

<script>
export default {
  props: {
    icon: String,
    color: String,
    title: String,
    value: [String, Number],
  },
};
</script>
